/**
 * The identifier of the addon.
 */
export const AddonName = "STORYBOOK_ADDON_DESIGNS";

/**
 * The name of the panel.
 */
export const PanelName = AddonName + "/panel";

/**
 * Addon events.
 */
export const Events = {
  UpdateConfig: AddonName + "/update_config",
};

/**
 * A key of story parameters.
 */
export const ParameterName = "design";
